import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';

import * as yup from 'yup';

/** Person passport data (for individual entrepreneur) */
export interface PersonPassportDataInterface {
  /** Passport serie */
  serie?: string;
  /** Passport number */
  number?: string;
  /** Register organization */
  org?: string;
  /** Passport registration date */
  date?: Date;
  /** Division code */
  code?: string;
  /** Registration address */
  address?: string;
}

/** Person passport data (for individual entrepreneur) - DTO schema */
export const PersonPassportDataDto = SerdeDtoClass.create<PersonPassportDataInterface>(ClientDtoKeysEnum.PERSON_PASSPORT_DATA_DTO, {
  serie: {
    optional: true,
    label: 'Серия',
    serializer: yup.string(),
  },
  number: {
    optional: true,
    label: 'Номер',
    serializer: yup.string(),
  },
  org: {
    optional: true,
    label: 'Выдан',
    serializer: yup.string(),
  },
  date: {
    optional: true,
    label: 'Дата выдачи',
    serializer: yup.date(),
  },
  code: {
    optional: true,
    label: 'Код подразделения',
    serializer: yup.string(),
  },
  address: {
    optional: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
});
